import type { ReactNode } from 'react';
import type { IconButtonProps, PopoverProps } from '@launchpad-ui/components';
import {
  Dialog,
  DialogTrigger,
  IconButton,
  OverlayArrow,
  Popover,
  Tooltip,
  TooltipTrigger,
} from '@launchpad-ui/components';

type OptionalProps = 'aria-label' | 'icon' | 'size' | 'variant';
type ContextualHelpProps = { placement?: PopoverProps['placement']; tooltipContent?: ReactNode; children?: ReactNode };

export function ContextualHelp({
  tooltipContent,
  placement,
  children,
  ...props
}: ContextualHelpProps &
  Omit<Omit<IconButtonProps, 'children'>, OptionalProps> &
  Partial<Pick<IconButtonProps, OptionalProps>>) {
  const iconButton = (
    <IconButton
      {...props}
      aria-label={props['aria-label'] ?? 'show more information'}
      icon={props.icon ?? 'info-circle-outline'}
      size={props.size ?? 'small'}
      variant={props.variant ?? 'minimal'}
    />
  );
  const trigger = tooltipContent ? (
    <TooltipTrigger>
      {iconButton}
      <Tooltip>{tooltipContent}</Tooltip>
    </TooltipTrigger>
  ) : (
    iconButton
  );

  return children ? (
    <DialogTrigger>
      {trigger}
      <Popover placement={placement}>
        <Dialog>{children}</Dialog>
        <OverlayArrow />
      </Popover>
    </DialogTrigger>
  ) : (
    trigger
  );
}
